/**
 * @generated SignedSource<<1d293c5fa575e282b09e51ccabc0fea4>>
 * @relayHash 5d73a886053db0c3167810d478cac2ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 95c94140fecba78cb87b8cfc0cf42eaf05d1a58960bd94f0b354baf1030acfc9

import type { ConcreteRequest, Query } from 'relay-runtime';
export type conversationReview_agentIdentityQuery$variables = {
  helpCenterAri: string;
};
export type conversationReview_agentIdentityQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly id?: string;
  } | null | undefined;
};
export type conversationReview_agentIdentityQuery = {
  response: conversationReview_agentIdentityQuery$data;
  variables: conversationReview_agentIdentityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "CsmAiHub"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "conversationReview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "conversationReview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "95c94140fecba78cb87b8cfc0cf42eaf05d1a58960bd94f0b354baf1030acfc9",
    "metadata": {},
    "name": "conversationReview_agentIdentityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "340a20f2d50cc5f77582b00676ed5abb";

export default node;
